import { QueryClient } from "@tanstack/react-query";

// Server-state only (ADR 0015 §5): no domain state duplicated client-side, the
// API's scoped/redacted reads are the cache. Conservative defaults for a pilot.
export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: false, staleTime: 30_000, refetchOnWindowFocus: false },
    },
  });
}
